import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import CircleIcon from "@mui/icons-material/Circle";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

import {
  Grid,
  List,
  IconButton,
  ListItemButton,
  Typography,
  Checkbox,
  ListItem,
  ListItemText,
  Chip,
} from "@mui/material";
import {
  getUsersByRoleId,
  updateUsersAction,
  deletePermanentUsers,
} from "./Services";
import { joinByKeys, getClassNames } from "./../../Js/Common";

import Confirmation from "../../Components/Modal/Confirmation";
import ConfirmationWithInput from "../../Components/Modal/ConfirmationWithInput";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { map, sortBy } from "lodash";

const UserList = (props) => {
  // Hooks
  const classes = useStyles();
  const navigation = useNavigate();
  const dispatch = useDispatch();

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const serverRole = useSelector((state) => state.defs.serverRole);

  const [userData, setUserData] = useState([]);
  const [allClasses, setAllClasses] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmForPermanentModal, setConfirmForPermanentModal] =
    useState(false);
  const [alertFlag, setAlertFlag] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [alertText, setAlertText] = useState("");

  useEffect(() => {
    const getInitialData = async () => {
      dispatch(commonSliceActions.resetState());
      console.log("props.rolesData", props.rolesData);
      if (props.rolesData) {
        if (props.rolesData.title.toLowerCase() === "learner") {
          let allClassesData = await getClassNames(userInfo.site_uuid);
          setAllClasses(allClassesData);
          if (localStorage.getItem("selectedClassIds")) {
            fetchUsersByRole(JSON.parse(localStorage.getItem("selectedClassIds")));
          } else if (allClassesData.length > 0)
            fetchUsersByRole(allClassesData[0].id);
        } else {
          fetchUsersByRole();
        }
      }
    };
    getInitialData();
  }, [props.rolesData]);

  useEffect(() => {
    if (userData.length > 0 && selectedUserIds.length === userData.length) {
      props.userSelection(true);
    } else if (selectedUserIds.length < userData.length) {
      props.userSelection(false);
    }
  }, [selectedUserIds]);

  useEffect(() => {
    if (props.clickOption) {
      switch (props.clickOption) {
        case "add":
          addUser();
          break;
        case "downloadTemplate":
          downloadTemplate();
          break;
        case "activeWebLogin":
          setWebLogin(true);
          break;
        case "inActiveWebLogin":
          setWebLogin(false);
          break;
        case "delete":
          deleteUsers();
          break;
        case "selectAll":
          selectUsers(true);
          break;
        case "unSelectAll":
          selectUsers(false);
          break;
        case "downloadActiveUsers":
          downloadUsers(true);
          break;
        case "downloadInActiveUsers":
          downloadUsers(false);
          break;
        default:
          setUserClass();
      }
      props.toggle();
    }
  }, [props.clickOption]);

  const selectUsers = (flg) => {
    let newArr = [];
    if (flg === true) {
      newArr = userData.map(function (obj) {
        return obj.uid;
      });
    }
    setSelectedUserIds(newArr);
  };

  const setUserClass = () => {
    fetchUsersByRole(props.clickOption);
    setSelectedUserIds([]);
  };

  const downloadUsers = async (flg) => {
    let params = {
      query: {
        $select: [
          "id",
          "uid",
          "name",
          "username",
          "passcode",
          "belongs_to",
          "allowedweblogin",
        ],
        $limit: -1,
        role_uid: props.rolesData.uid,
        site_uuid: userInfo.site_uuid,
        status: flg,
      },
    };
    let resUsersData = await getUsersByRoleId(params);
    console.log("resUsersData", resUsersData);
    exportUsersCSV(resUsersData.data, flg);
  };

  const exportUsersCSV = (res, flg) => {
    let csv = "";
    let username, passcode;
    let userType = props.rolesData.title.toLowerCase();
    if (userType === "learner") {
      csv =
        "FullName,FirstName,MiddleName,LastName,Username,Passcode,Class,Allow-Web-Login\n";
      for (let t = 0; t < allClasses.length; t++) {
        const filterObj = res.filter((e) => e.belongs_to == allClasses[t].id);
        for (let t1 = 0; t1 < filterObj.length; t1++) {
          if (
            filterObj[t1].username == null ||
            filterObj[t1].username == undefined
          )
            username = "";
          else username = filterObj[t1].username;

          if (
            filterObj[t1].passcode == null ||
            filterObj[t1].passcode == undefined
          )
            passcode = "";
          else passcode = filterObj[t1].passcode;

          let uname =
            filterObj[t1].name.firstname +
            " " +
            filterObj[t1].name.middlename +
            " " +
            filterObj[t1].name.lastname;
          csv =
            csv +
            uname +
            "," +
            filterObj[t1].name.firstname +
            "," +
            filterObj[t1].name.middlename +
            "," +
            filterObj[t1].name.lastname +
            "," +
            username +
            "," +
            passcode +
            "," +
            allClasses[t].value +
            "," +
            filterObj[t1].allowedweblogin;
          csv += "\n";
        }
      }
    } else {
      csv =
        "FullName,FirstName,MiddleName,LastName,Username,Passcode,Allow-Web-Login\n";
      for (let t = 0; t < res.length; t++) {
        if (res[t].username == null || res[t].username == undefined)
          username = "";
        else username = res[t].username;

        if (res[t].passcode == null || res[t].passcode == undefined)
          passcode = "";
        else passcode = res[t].passcode;

        let uname =
          res[t].name.firstname +
          " " +
          res[t].name.middlename +
          " " +
          res[t].name.lastname;
        csv =
          csv +
          uname +
          "," +
          res[t].name.firstname +
          "," +
          res[t].name.middlename +
          "," +
          res[t].name.lastname +
          "," +
          username +
          "," +
          passcode +
          "," +
          res[t].allowedweblogin;
        csv += "\n";
      }
    }
    let fileName = "";
    if (flg === true) fileName = "Active_" + userType + ".csv";
    else fileName = "Deactive_" + userType + ".csv";

    // document.getElementById('loader').style.display = 'none';
    let hiddenElement = document.createElement("a");
    hiddenElement.setAttribute(
      "href",
      "data:text/csv;charset=utf-8," + encodeURIComponent(csv)
    );
    hiddenElement.setAttribute("download", fileName);
    document.body.appendChild(hiddenElement);
    hiddenElement.click();
    document.body.removeChild(hiddenElement);
  };

  const setWebLogin = async (flg) => {
    if (selectedUserIds.length === 0) {
      setAlertText("Please select users");
      setAlertFlag(true);
      return;
    } else {
      let data = {};
      data.allowedweblogin = flg;
      data.is_synced = false;
      let params = {
        query: {
          site_uuid: userInfo.site_uuid,
          uid: selectedUserIds,
        },
      };
      await updateUsersAction(null, data, params);
      setSelectedUserIds([]);
    }
  };

  const deleteUsersData = async (deleteType = "soft") => {
    let data = {};
    data.status = false;
    data.is_synced = false;
    let params = {
      query: {
        site_uuid: userInfo.site_uuid,
        uid: selectedUserIds,
      },
    };
    await updateUsersAction(null, data, params);
    if (deleteType === "purge") {
      await deletePermanentUsers(null, data, params);
    }
    setSelectedUserIds([]);
  };

  const downloadTemplate = () => {
    let csv = "";
    if (props.rolesData.title.toLowerCase() === "learner") {
      csv =
        "GRNO,FirstName*,MiddleName,LastName,Gender*,BirthDay,BirthMonth,BirthYear,JoinDay,JoinMonth,JoinYear,Rollno,Class*,Username*,Password*\n";
      for (let t = 0; t < allClasses.length; t++) {
        let no = 1000 + t;
        let pwd = allClasses[t].value.replace("->", "_");
        console.log("allClasses[t].value", allClasses[t].value);
        let unm = "Jay_" + pwd;
        csv =
          csv +
          no +
          ",Jay,A,Roy,Male,02,11,2009,10,11,2015," +
          (t + 1) +
          "," +
          allClasses[t].value +
          "," +
          unm +
          "," +
          unm;
        csv += "\n";
      }
    } else {
      csv =
        "FirstName*,MiddleName,LastName,Gender*,BirthDay,BirthMonth,BirthYear,JoinDay,JoinMonth,JoinYear,Username*,Password*,Designation\n";
      csv = csv + "Amit,A,Rajai,Male,06,11,1990,11,12,2008,Amit,Amit,Maths";
      csv += "\n";
      csv =
        csv +
        "Manisha,J,Lakhani,Female,02,06,1990,20,04,2022,Manisha,Manisha,English";
      csv += "\n";
    }
    let hiddenElement = document.createElement("a");
    hiddenElement.setAttribute(
      "href",
      "data:text/csv;charset=utf-8," + encodeURIComponent(csv)
    );
    hiddenElement.setAttribute("download", props.rolesData.title + ".csv");
    document.body.appendChild(hiddenElement);
    hiddenElement.click();
    document.body.removeChild(hiddenElement);
  };

  const addUser = () => {
    console.log("add");
  };

  const deleteUsers = () => {
    if (selectedUserIds.length === 0) {
      setAlertText("Please select users");
      setAlertFlag(true);
    } else {
      setConfirmModal(true);
    }
  };

  const fetchUsersByRole = async (selectedClassId = null) => {
    let params = {
      query: {
        $limit: -1,
        role_uid: props.rolesData.uid,
        site_uuid: userInfo.site_uuid,
        status: true,
      },
    };
    console.log("selectedClassId",selectedClassId);
    if (selectedClassId != null) {
      params.query.belongs_to =
        typeof selectedClassId == "string"
          ? selectedClassId
          : map(selectedClassId, "id");
    }
    let resUsersData = await getUsersByRoleId(params);
    setUserData(
      sortBy(resUsersData.data, [
        (o) => {
          return o.name.firstname;
        },
      ])
    );
  };

  const setUserSelection = (id) => {
    let newArr = [...selectedUserIds];
    let position = newArr.indexOf(id);
    if (position === -1) {
      newArr.push(id);
    } else {
      newArr.splice(position, 1);
    }
    setSelectedUserIds(newArr);
  };

  const checkConfirmText = async () => {
    if (confirmText.trim() !== "delete-users") {
      setAlertText("Please enter valid text");
      setAlertFlag(true);
    } else {
      setConfirmForPermanentModal(false);
      await deleteUsersData("purge");
    }
  };

  return (
    <>
      <Grid container sx={{display: "block"}} justifyContent={"center"}>
        <Chip
          label={`Total Records: ${userData.length} | Selected Records: ${selectedUserIds.length}`}
          color="primary"
          variant="filled"
          sx={{
            backgroundColor: '#3eda00ff',
            fontWeight: "bold",
            px: 2,
            py: 1,
            mt:1,
            fontSize: "16px",
            borderRadius: "16px",
            alignSelf: "center"
          }}
        />
        {userData && userData.length > 0 ? (
          <Grid
            container
            spacing={1}
            marginTop={1}
             
            sx={{
              flexDirection: "row",
              justifyContent: "flex-start",
              alignContent: "flex-start",
              height: "52vh",
              overflow: "auto",
              px: 2,
            }}
          >
            {userData.map((objUser, index) => {
              return (
                <Grid item xs={6} key={`${index}_user`}>
                  <List sx={{ p: 0, m: 0, pb: 1 }}>
                    <ListItem 
                      sx={{ p: 0, backgroundColor: '#3eda00ff', borderRadius: 0, border: "none" }}
                      disablePadding
                      secondaryAction={
                        <IconButton
                          onClick={() => {
                            dispatch(
                              commonSliceActions.setParamsData({
                                rolesData: props.rolesData,
                                userUid: objUser.uid,
                                tabValue: props.rolesData.title.toLowerCase(),
                              })
                            );
                            navigation(`/Users/UserInfo/`);
                          }}
                          sx={{
                            "@media (min-width: 1636px)": {
                              fontSize: "1.4rem",
                            },
                          }}
                        >
                          <Typography
                            style={{
                              color: "#5f5600ff",
                              fontSize: "0.7vw",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                              },
                            }}
                          >
                            More Info
                          </Typography>
                          <ArrowForwardIosIcon sx={{ fontSize: "0.8vw" }} />
                        </IconButton>
                      }
                    >
                      <ListItemButton
                        sx={{ borderRadius: 15, border: "1px solid #e0e0e0" }}
                        onClick={() => {
                          setUserSelection(objUser.uid);
                        }}
                      >
                        {((serverRole == "WEB_HOST" &&
                          userInfo.rolesInfo.title.toLowerCase() == "admin") ||
                          (serverRole != "WEB_HOST" &&
                            userInfo.rolesInfo.title.toLowerCase() ==
                              "incharge")) && (
                          <Checkbox
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<CircleIcon />}
                            value={objUser.uid}
                            checked={selectedUserIds.indexOf(objUser.uid) != -1}
                            onClick={() => {
                              setUserSelection(objUser.uid);
                            }}
                          />
                        )}
                        <ListItemText
                          sx={{ m: 0, px: 0, py: 0.3 }}
                          primary={
                            <Typography
                              sx={{
                                fontSize: "0.9rem",
                                fontWeight: "500",
                                color: "#5f5600ff",
                                "@media (min-width: 1636px)": {
                                  fontSize: "1.2rem",
                                },
                              }}
                            >
                              {joinByKeys(
                                objUser.name,
                                ["firstname", "lastname"],
                                " "
                              )}
                            </Typography>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Grid>
              );
            })}
          </Grid>
        ) : (
          <Typography>No user available</Typography>
        )}
      </Grid>
      <Confirmation
        image="assign"
        primaryText="Are you sure you want to delete ?"
        visible={confirmModal}
        toggleModal={() => setConfirmModal(false)}
        positiveClick={() => {
          deleteUsersData();
          setConfirmModal(false);
        }}
        negativeClick={() => {
          setConfirmModal(false);
          setConfirmForPermanentModal(true);
        }}
        positiveText="Temporary delete"
        negativeText="Permanent delete"
      ></Confirmation>
      <Confirmation
        image="assign"
        primaryText={alertText}
        visible={alertFlag}
        alert={true}
        toggleModal={(flag) => setAlertFlag(flag)}
        timeout={2000}
      ></Confirmation>
      <ConfirmationWithInput
        image="delete"
        primaryText='Please type "delete-users" to remove user permanently.'
        visible={confirmForPermanentModal}
        toggleModal={() => setConfirmForPermanentModal(false)}
        positiveClick={() => {
          checkConfirmText();
        }}
        negativeClick={() => {
          setConfirmForPermanentModal(false);
        }}
        confirmInputText={confirmText}
        confirmInput={(text) => {
          setConfirmText(text);
        }}
        positiveText="Yes"
        negativeText="No"
      ></ConfirmationWithInput>
    </>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default UserList;
